import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function ActivityIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="ActivityIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <path
                d="M4.8 4C4.8 2.89543 5.69543 2 6.8 2H18.8C19.9046 2 20.8 2.89543 20.8 4V21C20.8 21.3746 20.5907 21.7178 20.2576 21.8892C19.9245 22.0606 19.5236 22.0315 19.2188 21.8137L12.8 17.2289L6.38124 21.8137C6.07643 22.0315 5.67549 22.0606 5.34242 21.8892C5.00935 21.7178 4.8 21.3746 4.8 21V4ZM18.8 4L6.8 4V19.0568L12.2188 15.1863C12.5665 14.9379 13.0335 14.9379 13.3812 15.1863L18.8 19.0568V4Z"
                fill="#43398E"
            />
        </SvgIcon>
    );
}
